import * as bootstrap from 'bootstrap';
import Helper from './helper';

import.meta.glob([
    '../img/**',
    '../video/**',
    '../files/**'
], { eager: true });

class App {
    constructor() {
        this.init();
    }

    init() {
        this.initStickyNavbar();
        this.honeyForms();
        this.asyncForms();
        this.cookies();
        this.initNavbarBackdrop();
    }

    initStickyNavbar() {
        const navbar = document.getElementById('main-navbar');

        const header = document.querySelector('header');

        if (navbar === null || header == null) {
            return false;
        }

        const scrolled = navbar.offsetHeight;

        const sticky = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= scrolled) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }

            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        });
    }

    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let turnstileWidgets = [];

        const initializeTurnstile = () => {
            if (typeof turnstile === 'undefined') {
                return false;
            }

            document.querySelectorAll('.cf-turnstile-widget').forEach(widget => {
                if (widget.dataset.initialized === 'true') {
                    return;
                }

                let widgetId = turnstile.render(widget, {
                    sitekey: widget.dataset.sitekey,
                    theme: 'light'
                });

                widget.dataset.initialized = 'true';
                turnstileWidgets.push(widgetId);
            });

            return true;
        };

        if (!initializeTurnstile() && document.querySelector('.cf-turnstile-widget')) {
            const turnstileInterval = setInterval(() => {
                if (initializeTurnstile()) {
                    clearInterval(turnstileInterval);
                }
            }, 100);
        }

        /**
         * Refresh Turnstile tokens before they expire.
         */
        let refreshTurnstile = () => {
            if (typeof turnstile === 'undefined') {
                return;
            }

            turnstileWidgets.forEach(widgetId => {
                turnstile.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshTurnstile();
        }, 4 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            let isSubmitting = false;

            form.addEventListener('submit', (e) => {
                e.preventDefault();

                if (isSubmitting) {
                    return;
                }

                isSubmitting = true;

                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    buttonSubmit.disabled = true;
                }

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh Turnstile
                        refreshTurnstile();

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';

                        isSubmitting = false;

                        if (buttonSubmit) {
                            buttonSubmit.disabled = false;
                        }
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh Turnstile
                    refreshTurnstile();

                    isSubmitting = false;

                    if (buttonSubmit) {
                        buttonSubmit.disabled = false;
                    }

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }


    initNavbarBackdrop() {
        const collapseEl = document.getElementById('main-navbar-collapse');

        if (!collapseEl) return;

        // Create backdrop element
        const backdrop = document.createElement('div');
        backdrop.classList.add('main-navbar__backdrop');
        document.body.appendChild(backdrop);

        collapseEl.addEventListener('show.bs.collapse', () => {
            backdrop.classList.add('main-navbar__backdrop--visible');
        });

        collapseEl.addEventListener('hide.bs.collapse', () => {
            backdrop.classList.remove('main-navbar__backdrop--visible');
        });

        // Close menu when backdrop is clicked
        backdrop.addEventListener('click', () => {
            bootstrap.Collapse.getInstance(collapseEl)?.hide();
        });
    }
}

window.addEventListener('load', () => new App());
